import React, { useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify';
import { IoHome } from "react-icons/io5";
import { PiKeyReturnFill } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import "./AddDailyTournamentForm.css"

const API = process.env.REACT_APP_API;

const AddDailyTournamentForm = () => {
    const navigate = useNavigate();
    const { token } = useAuth();

    const [form, setForm] = useState({
        name: "",
        date: "",
        registrationLink: "",
        facebookLink: "",
        showOnSite: true,
        showFlyer: true,
        showRegistration: true,
        showFacebook: true,
        showGallery: true,
    });

    const [flyerFile, setFlyerFile] = useState(null);
    const [flyerPreview, setFlyerPreview] = useState(null);
    const [gallery, setGallery] = useState([]); // אחיד עבור previews + files
    // const [galleryFiles, setGalleryFiles] = useState([]);
    // const [galleryPreviews, setGalleryPreviews] = useState([]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
    };

    const onFlyerChange = (e) => {
      const file = e.target.files[0];
      setFlyerFile(file || null);
      setFlyerPreview(file ? URL.createObjectURL(file) : null);
    };

    const onGalleryChange = (e) => {
      const files = Array.from(e.target.files || []);
      const newItems = files.map(f => ({ file: f, src: URL.createObjectURL(f) }));
      setGallery(prev => [...prev, ...newItems]);

      // setGalleryFiles(files);
      // setGalleryPreviews(files.map(f => URL.createObjectURL(f)));
    };

    const removeGalleryItem = (index) => {
      setGallery(prev => prev.filter((_, i) => i !== index));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();

        // שדות טקסט - בוליאנים
        Object.entries(form).forEach(([key, value]) => formData.append(key, value));

        if (flyerFile)
          formData.append("flyer", flyerFile);
        
        gallery.filter(g => g.file).forEach(g => formData.append("gallery", g.file));
        // galleryFiles.forEach((file) => {
        //   formData.append("gallery", file)
        // });

        try {
          await axios.post(`${API}/api/dailyTournaments`, formData, {
            headers: { 
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`   // 👈 חובה
            },
            });
          toast.success('✅ הטורניר נשמר בהצלחה!');
          navigate("/dailyTournaments"); // חזרה לרשימה אחרי שמירה
    
        } catch (err) {
          console.error("שגיאה בהוספת טורניר:", err);
          toast.error('❌ שמירת הטורניר נכשלה');
        }
    };

  return (
    <div className="tournament-form card">
      {/* אייקון הבית בפינה שמאלית עליונה */}
      <div className="home-icon">
          <IoHome title="עמוד הבית" size={30} onClick={() => navigate("/")}/>
      </div>
      <div className="back-icon" >
          <PiKeyReturnFill title="חזרה לעמוד הקודם" size={40} onClick={() => navigate("/tournaments")}/>
      </div>
      <h3>➕ הוספת טורניר חדש</h3>
      <form onSubmit={handleSubmit} className="form-grid">

        <label>שם הטורניר:
          <input type="text" name="name" placeholder="שם הטורניר" value={form.name} onChange={handleChange} required />
        </label>
        
        <label>תאריך:
          <input type="date" name="date" value={form.date} onChange={handleChange} required />
        </label>

        <label>פלייר (תמונה):
          <input type="file" accept="image/*" onChange={onFlyerChange} />
          {flyerPreview && <img src={flyerPreview} alt="תצוגה מקדימה" className="preview" />}
        </label>
        
        <label>קישור להרשמה:
          <input type="text" name="registrationLink" placeholder="קישור להרשמה" value={form.registrationLink} onChange={handleChange} />
        </label>

        <label>קישור לפייסבוק:
          <input type="text" name="facebookLink" placeholder="קישור לפייסבוק" value={form.facebookLink} onChange={handleChange} />
        </label>

        <label>גלריה:
          <input type="file" accept="image/*" multiple onChange={onGalleryChange} />
          {gallery.length > 0 && (
            <div className="preview-grid">
              {gallery.map((g, i) => (<div key={i} className="thumb">
                  <img src={g.src} alt={`g${i}`} />
                  <button type="button" onClick={() => removeGalleryItem(i)}>הסרה</button>
                </div>
              ))}
            </div>
          )}
        </label>

        <div className="checkbox-group">
          <label>
            הצגה באתר
          </label>
          <label>
            <input type="checkbox" name="showOnSite" checked={form.showOnSite} onChange={handleChange} />
            מוצג באתר
          </label>
          <label>
            <input type="checkbox" name="showFlyer" checked={form.showFlyer} onChange={handleChange} />
            פלייר
          </label>
          <label>
            <input type="checkbox" name="showRegistration" checked={form.showRegistration} onChange={handleChange} />
            כפתור הרשמה
          </label>
          <label>
            <input type="checkbox" name="showFacebook" checked={form.showFacebook} onChange={handleChange} />
            כפתור פייסבוק
          </label>
          <label>
            <input type="checkbox" name="showGallery" checked={form.showGallery} onChange={handleChange} />
            גלריה
          </label>
        </div>
        
        <div className="buttons">
          <button type="submit">💾 שמור טורניר</button>
          <button onClick={() => navigate("/dailyTournaments")}>⬅️ חזרה</button>
        </div>
      </form>
    </div>
  );
};

export default AddDailyTournamentForm;